export class CadastroUsuarioLoteReturn {
    success: boolean;
    message: string; 
}